import { render } from "./inventory-status-report.vue?vue&type=template&id=2c4cab7f&scoped=true"
import script from "./inventory-status-report.vue?vue&type=script&lang=js"
export * from "./inventory-status-report.vue?vue&type=script&lang=js"

import "./inventory-status-report.vue?vue&type=style&index=0&id=2c4cab7f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4cab7f"]])

export default __exports__